import apiClient from './apiClient';

export const loginUser = async (data) => {
    try {
        const response = await apiClient.post('/auth/login', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const hrLoginUser = async (data) => {
    try {
        const response = await apiClient.post('/auth/hr-login', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const verifyToken = async () => {
    try {
        const response = await apiClient.get('/auth/verify-token');
        return response.data;
    } catch (error) {
        throw error;
    }
};
